import React from 'react'
import PropTypes from 'prop-types'

import { Table } from 'gdpp-components/dist/cjs/components/molecules'
import GridContainer from '../../atoms/FoundationGrid/GridContainer'

import './style.scss'

const FundDetailDocumentTab = ({ fundDocumentTable, id, children }) => {
  const { tableData } = fundDocumentTable
  return (
    <GridContainer extraClasses="fil-fund-detail__tab-document">
      {children || <Table {...tableData} id={id} isAutoFitWidth size="small" isScrollbale={false} />}
    </GridContainer>
  )
}

FundDetailDocumentTab.propTypes = {
  fundDocumentTable: PropTypes.object,
  id: PropTypes.string.isRequired,
  children: PropTypes.any
}

FundDetailDocumentTab.defaultProps = {
  fundDocumentTable: {},
  children: null
}

export default FundDetailDocumentTab
